import React from 'react'

import Confirm2faForm from './Confirm2faForm'

export default function Confirm2faModal({
  closeModal,
  phoneNumber,
  twofaMethod,
}: {
  closeModal: () => void
  phoneNumber?: string
  twofaMethod: 'app' | 'sms'
}) {
  const onSuccess = () => {
    closeModal()
    window.location.reload()
  }

  return (
    <div className="Confirm2faModal">
      <Confirm2faForm
        onSuccess={onSuccess}
        phoneNumber={phoneNumber}
        showSkip={false}
        twofaMethod={twofaMethod}
        userFlow="signup"
      />
    </div>
  )
}
